import { ErrorMessage, errorMessagesSection, faExclamationCircle, FontAwesomeIcon, FormStyle,
         infoPlaceholderSection, React, Select, SelectStyle, TRANSLATION } from "@/imports-files/components/custom-select";
import AsyncSelect from 'react-select/async';


export function AsyncSelectInput(props)
{
  let defaultClass = props.career ? props.career :  SelectStyle.Form__CustomSelect
  let currency_present = props.isCurrency ? SelectStyle.Form__select_currency : '';
    return(
            <div className= {currency_present}>
              { props.isCurrency && <span className = {SelectStyle.Form__currency_symbol}>{props.currencySymbol}</span> }
              <AsyncSelect
                  defaultOptions
                  className         =   { props.style != undefined ? SelectStyle.Form__ErrorCustomSelect : defaultClass }
                  classNamePrefix   =   "customSelect"
                  defaultValue      =   { props.default != '' ? props.options ? props.options[GetIndexOfSelectFromValues(props.options, props.default)]: '' : '' }
                  instanceId        =   { props.name }
                  name              =   { props.name }
                  onChange          =   { props.onChange }
                  // options           =   { props.options}
                  loadOptions       =   { props.loadOptions}
                  components        =   { props.components }
                  isDisabled        =   { props.disabled}
                  placeholder       =   { props.placeholder || TRANSLATION('placeholder:select:please') }
                  ref               =   { props.reference }
                  styles            =   {{ menu: provided => ({ ...provided, zIndex: 999999 }) }}
                  menuPlacement     =   'auto'
                  value             =   { props.value }
                  noOptionsMessage  =   {() => TRANSLATION('placeholder:select:no_options')}
                />

                {
                  props.style != undefined ?  errorMessagesSection( props.name, FormStyle, props.formik, props.custom_class || '')
                                           :  infoPlaceholderSection(props.infoPlaceholder, FormStyle)
                }

            </div>
          )
}


export function GetIndexOfSelectFromValues(select_options, value)
{
   for ( let index in select_options)
   {
      if(select_options[index].value == value)
      {
        return index;
      }
   }

}